import configuration from '@common/Services/configuration-service';
import userPreferences from '@common/Services/preferences-service';
import { InitializeLocalStorageRefresh } from '@common/Services/local-storage-service';
import { InitializeHelpText } from '@common/Globals/help-text';
import InputFinder from '@common/Globals/input-finder';
import InputNumber from '@common/Globals/input-number';
import ConfirmationModals from '@common/Globals/confirmation-modal';

(async () => await configuration.Initialize())();
(async () => await userPreferences.Initialize())();
(async () => await InitializeLocalStorageRefresh())();
(async () => await InitializeHelpText())();
$(InputFinder.focusInputFromQueryString);
$(InputNumber.preventNegativeNumbers);
$(ConfirmationModals.configureConfirmationModals);

import './assets';
import '@common/Globals/global-ui-bindings';
import '@common/Globals/notification-loader';
import '@common/Controls/input-formatters';
import '@common/Controls/save-changes-warning';